import { Grid } from '@mui/material';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import TableComponent from 'src/components/tableVersion2';
import { sendRequest, serviceList } from 'src/utils';

function ListDeviceTakeTable({
    month = moment().format('MM'),
    year = moment().format('YYYY'),
    department = null,
    staff = null,
    option = 'year',
}) {
    const [getFlags, setGetFlags] = useState(false);
    const { t } = useTranslation();
    const getRef = useRef(false);
    const tableRef = useRef(false);
    const [dataTable, setDataTable] = useState([]);
    const [total, setTotal] = useState(0);
    // const throttled = useRef(debounce(() => getData(), 1000));
    const table = {
        cols: [
            { title: 'stt', field: 'index', type: 'index', show: true, sort: false },
            {
                title: 'code_device',
                field: 'device_cd',
                type: 'have_delete',
                show: true,
                sort: true,
            },
            {
                title: 'name_device',
                field: 'device_nm',
                show: true,
                sort: true,
            },
            {
                title: 'quantity_category',
                field: 'qty',
                type: 'unit',
                show: true,
                sort: true,
            },
            {
                title: 'current_price',
                field: 'price',
                type: 'money',
                show: true,
                sort: true,
            },
            {
                title: 'total',
                field: 'tich_gia',
                type: 'money',
                show: true,
                sort: true,
            },
        ],
        data: [],
        total: 0,
        lastId: 99999999999,
        valueSearch: '',
    };
    const searchValueDeboun = useRef('');
    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, [month, year, department, staff, option]);

    const searchValue = (value) => {
        if (!value) {
            value = '';
        }
        searchValueDeboun.current = value;
        // setvalueSearch(value);
        getData();
    };
    const getData = () => {
        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;
        console.log(['month' + month, 'year' + year, department, staff, option]);

        let start = '';
        let end = '';
        const monthYear = year + month;
        if (option === 'month') {
            start = monthYear + '01';
            const lastDayOfMonth = moment(start, 'YYYYMMDD').endOf('month').format('DD');

            end = monthYear + lastDayOfMonth;
        } else {
            start = year + '0101';

            end = year + '1231';
        }
        const InVal = [start, end, department?.id || 0, staff?.id || 0, searchValueDeboun.current.trim()];
        sendRequest(serviceList.get_device_etk, InVal, getDataResult, true, timeOutFunct, 40000);
    };
    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0]['o_1'];
            setDataTable(data);
            setTotal(message.proc_data.rowTotal || 0);
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        getRef.current = false;
    };
    const renderSubtitleTable = () => {
        let object = '';
        if (department) {
            object = department?.departs_nm;
        }
        if (staff) {
            object = staff?.user_nm;
        }
        let time = '';
        if (option === 'month') {
            const monthYear = month + '/' + year;
            const startTime = '01/' + monthYear;
            const lastDayOfMonth = moment(startTime, 'DD/MM/YYYY').endOf('month').format('DD');

            const endTime = lastDayOfMonth + '/' + monthYear;
            time = startTime + ' - ' + endTime;
        } else {
            const startTime = '01/01/' + year;
            const endTime = '31/12/' + year;
            time = startTime + ' - ' + endTime;
        }
        const result = object ? object + ': ' + time : time;

        return result;
    };
    return (
        <>
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{ width: '100%' }}
                sx={{ overflowY: 'scroll', height: '70vh' }}
            >
                <TableComponent
                    title="listDeviceTake"
                    subTitle={renderSubtitleTable()}
                    ref={tableRef}
                    cols={table.cols}
                    dataTable={dataTable}
                    total={total}
                    getData={searchValue}
                />
            </Grid>
            {/* Danh sách chi tiết thiết bị lấy sử dụng */}
            {/* _______________________ END _______________________ */}
        </>
    );
}

export default ListDeviceTakeTable;
